'use strict';
import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { debounceTime, switchMap } from "rxjs/operators";

import { InfoDialogComponent } from '../../core/dialogs/info-dialog/info-dialog.component';
import { ConfirmDialogComponent } from '../../core/dialogs/confirm-dialog/confirm-dialog.component';

import { ClienteMetodoPagamento } from '../shared/cliente-metodo-pagamento.model';
import { ClienteMetodoPagamentoService } from '../shared/cliente-metodo-pagamento.service';

export interface DialogData {
    clienteMetodoPagamentoId: number;
    clienteId: number;
}

@Component({
    selector: 'cliente-metodo-pagamento',
    templateUrl: 'cliente-metodo-pagamento.component.html',
})

export class ClienteMetodoPagamentoComponent {

    clienteMetodoPagamentoForm: FormGroup;
    maximizado: boolean;

    constructor(
        public dialog: MatDialog,
    private _snackBar: MatSnackBar,
        public dialogRef: MatDialogRef<ClienteMetodoPagamentoComponent>,
        private _formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public IClienteMetodoPagamento: DialogData,
        private clienteMetodoPagamentoService: ClienteMetodoPagamentoService) {
    }

    ngOnInit() {

        this.maximizado = false;

        this.clienteMetodoPagamentoForm = this._formBuilder.group(new ClienteMetodoPagamento());

        this.clienteMetodoPagamentoForm.get('clienteMetodoPagamentoId').setValue(this.IClienteMetodoPagamento.clienteMetodoPagamentoId);
        this.clienteMetodoPagamentoForm.get('clienteId').setValue(this.IClienteMetodoPagamento.clienteId);

        if (this.IClienteMetodoPagamento.clienteMetodoPagamentoId > 0) {

            this.buscarClienteMetodoPagamento(this.IClienteMetodoPagamento.clienteMetodoPagamentoId);
        }

        this.restaurarDialog();

        this.onChanges();
    }

    onChanges(): void {

        
    }

    fecharDialog() {
        this.dialogRef.close();
    }

    maximizarDialog() {
        this.dialogRef.updateSize('100%', '100%');
        this.maximizado = true;
    }

    restaurarDialog() {
        let innerWidth = window.innerWidth;

        if (innerWidth < 1024) {
            this.dialogRef.updateSize('90%', '100vh');
        }
        else {
            this.dialogRef.updateSize('60%', '100vh');
        }
        this.maximizado = false;
    }

    buscarClienteMetodoPagamento(clienteMetodoPagamentoId: number) {

        this.clienteMetodoPagamentoService.get(clienteMetodoPagamentoId).subscribe(data => {

            this.clienteMetodoPagamentoForm.patchValue(data.body);

        })
    }

    salvar(){

        let clienteSevico = this.clienteMetodoPagamentoForm.value;

        if (this.IClienteMetodoPagamento.clienteMetodoPagamentoId == 0) {

            this.clienteMetodoPagamentoService.post(clienteSevico).subscribe(data => {

                        this._snackBar.open("Registro Salvo com Sucesso");

                this.fecharDialog();


            });
        }
        else {

            this.clienteMetodoPagamentoService.put(clienteSevico, clienteSevico.clienteMetodoPagamentoId).subscribe(data => {

                        this._snackBar.open("Registro Salvo com Sucesso");

                this.fecharDialog();


            });
        }
    }
}
